import { ref, computed, Ref } from '@vue/composition-api';
import { CompanyModel } from '@/api/models';

const selectedCompany: Ref<CompanyModel | null> = ref(null);
const isSelectedCompany = computed(() => selectedCompany.value?.id);

export { selectedCompany, isSelectedCompany };
